import axios from 'axios';
import { getApiClientFront, getApiClientBack, getURLFront } from "../api/api";
import { verAviso } from '../components/VerAviso/VerAviso';

// const localUrlMap = {
//   // "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es",
//   "pruebasede.oepm.gob.es": "https://pruebasede.oepm.gob.es/bopi",
//   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es",
//   "bopiweb.oepm.es": "https://bopiweb.oepm.es",
//   "localhost": "http://localhost:5000",
//   "defaultApiUrl": "Error",
// };

// const localBaseURL = localUrlMap[window.location.hostname] || localUrlMap["defaultApiUrl"];
// // const localBaseURL = "http://localhost:3000";

// const apiUrlMap = {
//   // "pruebabopiweb.oepm.es": "https://pruebabopiweb.oepm.es/apibopiweb",
//   "pruebasede.oepm.gob.es": "https://pruebasede.oepm.gob.es/bopi/apibopiweb",
//   "prebopiweb.oepm.es": "https://prebopiweb.oepm.es/apibopiweb",
//   "bopiweb.oepm.es": "https://bopiweb.oepm.es/apibopiweb",
//   "defaultApiUrl": "Error",
//   "localhost": "http://localhost:5000",
// };

// const api = axios.create({
//   // baseURL: "http://localhost:8080/BopiWeb/"
//   baseURL: apiUrlMap[window.location.hostname] || apiUrlMap["defaultApiUrl"],
// });

export const publicacionesBopi = async (tomo) => {
  const api = await getApiClientBack();
  const response = await api.get('/ultimasPublicaciones', {
    params: { tomo },
  });
  return response.data;
};

export const validarRefrescarToken = async (token, user) => {
  const api = await getApiClientBack();
  const response = await api.post('/validarRefrescarToken', {
      token: token,
      user: user,
    });
  return response.data;
};

export const descargarSumario = async (tomo) => {
  var endpoint = "/descargarSumario";
  try {
    const api = await getApiClientBack();
    const response = await api.post(
      endpoint, {
      tomo: tomo,
    }, {
      responseType: 'blob',
    }
    );
    const blob = new Blob([response.data], {
      type: "application/pdf"
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Sumario_T`+tomo+`.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error al descargar el documento:", error);
    if (error.response.status == 403) {
      return error.response.status;
    } else {
      console.error("No existe el documento solicitado o existe algún problema: ", error);
      // alert("No existe el documento solicitado o existe algún problema. Si el problema persiste póngase en contacto con el equipo de desarrollo. Perdone las molestias.");
      verAviso("No existe el documento solicitado o existe algún problema. Si el problema persiste póngase en contacto con el equipo de desarrollo. Perdone las molestias.");
    }
  }
};


export const descargarDocumento = async (publicacion, Tipo, tomo, fechaFormateada, token, user) => {
  var endpoint = "/descargarDocumento";
  if (Tipo=="PDF") {
    endpoint='/descargarDocumentoPdf';
  }
  try {
    const api = await getApiClientBack();
    const response = await api.post(
      endpoint,
      {
        user: user,
        idUcmPdf: publicacion.idPdfUcm, 
        idUcmHtml: publicacion.idHtmlUcm,
        idUcmXml: publicacion.idXmlUcm,
        tipo: Tipo,
        aplicacion: "bopiweb",
        descAuditoria: `Descarga TOMO ${tomo} en formato ${Tipo}`,
        token: token,
        fecha: fechaFormateada
      },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        responseType: 'blob',
      }
    );

    const blob = new Blob([response.data], {
      type:
        Tipo === "PDF"
          ? "application/pdf"
          : Tipo === "XML"
          ? "application/xml"
          : "text/html",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `TOMO${tomo}_${fechaFormateada}.${Tipo.toLowerCase()}`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error al descargar el documento:", error);
    if(error.response.status==403){
      return error.response.status;
    }else{
      console.error("No existe el documento solicitado o existe algún problema: ", error);
      // alert("No existe el documento solicitado o existe algún problema. Si el problema persiste póngase en contacto con el equipo de desarrollo. Perdone las molestias.");
      verAviso("No existe el documento solicitado o existe algún problema. Si el problema persiste póngase en contacto con el equipo de desarrollo. Perdone las molestias.");
      return -1;
    }
  }

  return 0;
  
};

export const buscarPublicaciones = async (tomo, fechaFormateada, cveInput) => {
  const localBaseURL = await getURLFront();
  try {
    if (cveInput != "" && cveInput != null) {
      const resultado = await publicacionesByCve(cveInput);

      const resultadoFormateado = {
        id_PAGINA_CSV: resultado.id_PAGINA_CSV,
      };

      
      const nuevaVentana = window.open(
        localBaseURL + "/visorPdf",
        "visorPdf",
        "width=800,height=600"
      );

      let expectedOrigin = "";
      try {
        expectedOrigin = new URL(localBaseURL).origin;
      } catch (e) {
        console.error("Fallo al construir URL con localBaseURL:", localBaseURL);
        console.error(e);
      }

      const handleReady = (event) => {
        if (event.origin === expectedOrigin && event.data?.tipo === "visorPdfReady") {
          event.source.postMessage(
            { tipo: "enviarResultado", resultado: resultadoFormateado },
            event.origin
          );
          window.removeEventListener("message", handleReady);
        }
      };
      window.addEventListener("message", handleReady);
      return resultado;
    } else {
      const resultado = await publicacionesBopiByFechaPublicacion(tomo, fechaFormateada);
      return resultado;
    }
  } catch (error) {
    if (cveInput !== "" && cveInput !== null) {
      console.error("Error al obtener datos por CVE:", error);
      // alert("No se pudo obtener la publicación. Revisa el CVE y si es correcto ponte en contacto con el equipo de desarrollo. Perdone las molestias.");
      verAviso("No se pudo obtener la publicación. Revisa el CVE y si es correcto ponte en contacto con el equipo de desarrollo. Perdone las molestias.");
    } else {
      console.error("Error al obtener datos por Fecha:", error);
      // alert("No se pudo obtener la publicación. Revisa la Fecha y si es correcta ponte en contacto con el equipo de desarrollo. Perdone las molestias.");
      verAviso("No se pudo obtener la publicación. Revisa la Fecha y si es correcta ponte en contacto con el equipo de desarrollo. Perdone las molestias.");
    }
    
  }

};

export const publicacionesBopiByFechaPublicacion = async (tomo, fechaPublicacion) => {
  const api = await getApiClientBack();
  const response = await api.get(`/publicacionesBopiTomoYFecha/${tomo}/${fechaPublicacion}`);
  return response.data;
};

export const publicacionesByCve = async (cveInput) => {
  const api = await getApiClientBack();
  const response = await api.get(`/buscarPublicacionesCve/${cveInput}`);
  return response.data;
};


export const descargarDocumentoPdfCompleto = async (fecha, tomo) => {
  try {
    const api = await getApiClientBack();
    const response = await api.post(
      '/descargarDocumentoPdfCompleto',
      null,
      {
        params: {
          fecha: fecha,
          tomo: tomo
        },
        responseType: 'blob'
      }
    );

    const blob = new Blob([response.data], {
      type: "application/pdf"
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `TOMO${tomo}_${fecha}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error al descargar el documento:", error);
    if(error.response.status==403){
      return error.response.status;
    }else{
      console.error("No existe el documento solicitado o existe algún problema: ", error);
      // alert("No existe el documento solicitado o existe algún problema. Si el problema persiste póngase en contacto con el equipo de desarrollo. Perdone las molestias.");
      verAviso("No existe el documento solicitado o existe algún problema. Si el problema persiste póngase en contacto con el equipo de desarrollo. Perdone las molestias.");
    }
  }
};